/**
 * Standard trailing-edge debounce: `fn` runs `delayMs` after the last call.
 * The returned function exposes `cancel()` to drop any pending invocation.
 */
export function debounce<T extends (...args: any[]) => void>(fn: T, delayMs: number): T & { cancel: () => void } {
  let timerId: ReturnType<typeof setTimeout> | null = null;

  const debounced = function (this: unknown, ...args: any[]) {
    if (timerId !== null) {
      clearTimeout(timerId);
    }
    timerId = setTimeout(() => {
      timerId = null;
      fn.apply(this, args);
    }, delayMs);
  } as T & { cancel: () => void };

  debounced.cancel = () => {
    if (timerId !== null) {
      clearTimeout(timerId);
      timerId = null;
    }
  };

  return debounced;
}
